import React from 'react';
import clsx from 'clsx';
import styles from './Sidebar.module.scss';

const SidebarItem = ({
  href,
  active = false,
  children,
  ...props
}) => {
  const className = clsx(
    styles.SidebarItem,
    active && styles['SidebarItem--active']
  );

  if (href) {
    return (
      <a className={className} href={href} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={className} {...props}>
      {children}
    </button>
  );
};

export default SidebarItem;
